import React from 'react';
import { Partner } from '../../types/api';
import { formatStoredPhone } from '../../utils/phone';

interface ContactsPanelProps {
  partner: Partner | null;
  onEdit: () => void;
}

/** Площадки рисуются одинаково: площадка — не бренд кабинета. */
const LINK_ICONS: Record<string, React.ReactNode> = {
  WhatsApp: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981z" />
    </svg>
  ),
  Instagram: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069h.002zm0 3.675a6.162 6.162 0 100 12.324A6.162 6.162 0 0012 5.838zm0 10.162a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  ),
  Facebook: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M22.675 0h-21.35C.597 0 0 .597 0 1.325v21.351C0 23.403.597 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.323-.597 1.323-1.325v-21.35C24 .597 23.403 0 22.675 0z" />
    </svg>
  ),
  LinkedIn: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.064 2.064 0 110-4.128 2.064 2.064 0 010 4.128zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  ),
  YouTube: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  ),
  Сайт: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm6.93 6h-2.95a15.7 15.7 0 00-1.38-3.56A8.03 8.03 0 0118.93 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14a7.87 7.87 0 010-4h3.38a16.6 16.6 0 000 4H4.26zm.81 2h2.95c.3 1.26.76 2.46 1.38 3.56A7.99 7.99 0 015.07 16zm2.95-8H5.07a7.99 7.99 0 014.33-3.56A15.7 15.7 0 008.02 8zM12 19.96A13.9 13.9 0 0110.09 16h3.82A13.9 13.9 0 0112 19.96zM14.34 14H9.66a14.9 14.9 0 010-4h4.68a14.9 14.9 0 010 4zm.25 5.56c.62-1.1 1.08-2.3 1.38-3.56h2.95a7.99 7.99 0 01-4.33 3.56zM16.36 14a16.6 16.6 0 000-4h3.38a7.87 7.87 0 010 4h-3.38z" />
    </svg>
  ),
};

interface ContactLink {
  label: string;
  value: string;
  href: string;
}

function buildLinks(partner: Partner | null): ContactLink[] {
  const links: ContactLink[] = [];
  if (!partner) return links;

  if (partner.whatsapp) {
    links.push({
      label: 'WhatsApp',
      // Профиль хранит номер как +77011234567 — показываем с маской.
      value: formatStoredPhone(partner.whatsapp),
      href: `https://wa.me/${partner.whatsapp.replace(/\D/g, '')}`,
    });
  }
  if (partner.instagram) {
    // Партнёры вбивают сюда и «@ник», и полную ссылку — приводим к нику,
    // иначе на экране появляется «@https://instagram.com/…».
    const handle = partner.instagram
      .trim()
      .replace(/^https?:\/\/(www\.)?instagram\.com\//i, '')
      .replace(/^@/, '')
      .replace(/\/+$/, '');
    links.push({ label: 'Instagram', value: `@${handle}`, href: `https://instagram.com/${handle}` });
  }
  if (partner.facebook) links.push({ label: 'Facebook', value: 'Перейти', href: partner.facebook });
  if (partner.linkedin) links.push({ label: 'LinkedIn', value: 'Перейти', href: partner.linkedin });
  if (partner.youtube) links.push({ label: 'YouTube', value: 'Смотреть', href: partner.youtube });
  if (partner.website) {
    links.push({ label: 'Сайт', value: partner.website.replace(/^https?:\/\//, ''), href: partner.website });
  }

  return links;
}

export const ContactsPanel: React.FC<ContactsPanelProps> = ({ partner, onEdit }) => {
  const links = buildLinks(partner);

  return (
    <section className="qp-panel">
      <header className="qp-panel-head">
        <h2 className="qp-label">Контакты</h2>
        <button type="button" className="qp-link" onClick={onEdit}>
          {links.length > 0 ? 'Изменить' : 'Добавить'}
        </button>
      </header>

      {links.length === 0 ? (
        <p className="qp-faint" style={{ margin: 0, fontSize: 13 }}>
          Ни одной ссылки. Клиенту некуда написать после того, как он вас нашёл.
        </p>
      ) : (
        <div className="qp-hairlist">
          {links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noreferrer"
              className="qp-contact"
            >
              <span className="qp-contact-icon">{LINK_ICONS[link.label]}</span>
              <span style={{ minWidth: 0 }}>
                <span className="qp-fact-k">{link.label}</span>
                <span className="qp-contact-value">{link.value}</span>
              </span>
            </a>
          ))}
        </div>
      )}
    </section>
  );
};
